import React, { useState, useEffect } from 'react';
import './index.css';
import {
  Container,
  Col,
  Row,
  Input,
  Modal,
  ModalBody,
  Label,
  Table,
} from 'reactstrap';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  editCommitment,
  getProducts,
  dealerDocumentUpload,
  addCommitment,
  editDealer,
  getState,
} from '../../../constants/apiCalls';
import ModalService from '../../../services/ModalService';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import Document from '../../../Components/Document';
import Document2 from '../../../Components/Document2';
import { DashBoardTitle } from '../../../Components/Title';
import uploadImg from '../../../images/upload2.png';
import downloadImg from '../../../images/download2.png';
import closeImg from '../../../images/close.png';
import whatsAppImg from '../../../images/whatsapp.png';
import gmailImg from '../../../images/gmail.png';
import { Breadcrumbs } from '../../../Components/Breadcrumbs/Breadcrumbs';
import Storage from '../../../services/Storage';
import { AddUserButton, CommonButton, CommonCommitment } from '../../../Components/CommonComponents';
import FYearService from '../../../services/FYearService';
import { CommitmentModal } from '../../../Components/CustomModal';
import { handleErrorMessage } from '../../../utils/utils';
import UrlService from '../../../services/UrlService';
import { useDispatch, useSelector } from 'react-redux';
import { dealerInfoAction } from '../../../reducers/DealerReducer';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

const BusinessCommitment = () => {
  let fYYear = FYearService.getFYear();
  let location = useLocation();
  const navigate = useNavigate();
  let stringArr = location.pathname.split(/(\d+)/);
  let userId = stringArr[1];

  const [isLoading, setIsloading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  const [productId, setProductId] = useState('');
  const [product, setProduct] = useState('');
  const [unitType, setUnitType] = useState('');
  const [productUnit, setProductUnit] = useState('');
  const [isKycRequired, setIsKycRequired] = useState(false);
  const [title, setTitle] = useState({});

  const [upload, setUpload] = useState('');

  const [editCommitmentId, setEditCommitmentId] = useState('');
  const [commitment, setCommitment] = useState('');
  const [secondYearcommitment, setSecondYearCommitment] = useState('');
  const [thirdYearcommitment, setThirdYearCommitment] = useState('');
  const [commitmentModal, setCommitmentModal] = useState(false);
  const [commitObj, setCommitObj] = useState({});


  // Preview Modal
  const [previewModal, setPreviewModal] = useState(false);
  const [selectedTerritory, setSelectedTerritory] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [navigationName, setNavigationName] = useState('');
  const [activeOwner, setActiveOwner] = useState('');
  const [isPrinting, setIsPrinting] = useState(false);

  const dispatch = useDispatch();
  const { dealerObj } = useSelector(state => state.DealerReducer);

  useEffect(() => {
    if (isPrinting) {
      window.print();
      setIsPrinting(!isPrinting);
    }
  }, [isPrinting]);

  useEffect(() => {
    if (userId) {
      // getCommitments(userId);
      setIsloading(true);
      dispatch(dealerInfoAction(parseInt(userId), setIsloading));
    }
  }, [upload]);

  useEffect(() => {
    let filteredOwner = dealerObj && dealerObj.owners && dealerObj.owners.length > 0 ? dealerObj.owners.filter(val => val.is_primary_contact === true) : [];
    setActiveOwner(filteredOwner);
    setNavigationName(dealerObj);
    setUpload(dealerObj.commitment);
    setIsKycRequired(dealerObj.is_approved);
    setSelectedTerritory(dealerObj.territory_name);
    getStatesData(dealerObj.state_id);
    setTitle({ name: dealerObj.business_name, page: dealerObj.page_5 });
  }, [dealerObj])

  useEffect(() => {
    getProductsDetail();
  }, [])

  useEffect(() => {
    getCommitData();
  }, [])

  const getCommitData = (obj) => {
    if (obj) {
      setCommitObj(obj);
    }
  }

  const getStatesData = (StateId) => {
    getState((res) => {
      const { success, data, error } = res;
      if (success === true && StateId && data) {
        let filteredState = data.filter((val) => val.id === StateId);
        setSelectedState(filteredState[0].name);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
    });
  };

  const getProductsDetail = () => {
    getProducts((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setProduct(data);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
    });
  };
  const handleProduct = (e, key) => {
    let val = e.target.value;
    if (key === 1) {
      setProductId(val);
      let value = product.filter((vals) => vals.id === +val);
      setUnitType(value[0].unit_type);
      setProductUnit(value[0].product_unit);
    } else if (key === 2) {
      setCommitment(val);
    } else if (key === 3) {
      setSecondYearCommitment(val);
    } else if (key === 4) {
      setThirdYearCommitment(val);
    }
  };

  const handleAddCommitment = (e, key) => {
    setCommitmentModal(!commitmentModal);
    setCommitment('');
    setSecondYearCommitment('');
    setThirdYearCommitment('');
    setProductId('');
    setUnitType('');
    setProductUnit('');
    setEditCommitmentId('');
  };

  const handleEditCommitment = (val, key) => {
    setProductId(val.product_id);
    setCommitment(val.commitments_new[0].first_year_commitment);
    setSecondYearCommitment(val.commitments_new[1].second_year_commitment);
    setThirdYearCommitment(val.commitments_new[2].third_year_commitment);
    setUnitType(val.unit_type);
    setProductUnit(val.product_unit);
    setEditCommitmentId(val.uuid);
    setCommitmentModal(!commitmentModal);
  };

  const handleSubmitCommmitment = (e) => {
    e.preventDefault();
    let filteredUnitType = product.filter((vals) => vals.id === +productId);
    let filteredUnitprice = filteredUnitType[0].unit_price;
    let total =
      parseFloat(commitment) +
      parseFloat(secondYearcommitment) +
      parseFloat(thirdYearcommitment);
    let totalPrice =
      filteredUnitprice * commitment +
      filteredUnitprice * secondYearcommitment +
      filteredUnitprice * thirdYearcommitment;
    let payload = {
      user_id: userId,
      product_id: parseInt(productId),
      unit_type: filteredUnitType[0].unit_type,
      total: parseFloat(total),
      commitments: [
        { first_year_commitment: parseFloat(commitment) },
        { second_year_commitment: parseFloat(secondYearcommitment) },
        { third_year_commitment: parseFloat(thirdYearcommitment) },
      ],
      commitment_prices: [
        {
          first_year_commitment_price: filteredUnitprice * commitment,
        },
        {
          second_year_commitment_price:
            filteredUnitprice * secondYearcommitment,
        },
        {
          third_year_commitment_price: filteredUnitprice * thirdYearcommitment,
        },
      ],
      total_price: totalPrice,
    };
    if (editCommitmentId) {
      let editpayload = {
        uuid: editCommitmentId,
        product_id: parseInt(productId),
        unit_type: unitType,
        total: parseFloat(total),
        commitments: [
          { first_year_commitment: parseFloat(commitment) },
          { second_year_commitment: parseFloat(secondYearcommitment) },
          { third_year_commitment: parseFloat(thirdYearcommitment) },
        ],
        commitment_prices: [
          {
            first_year_commitment_price: filteredUnitprice * commitment,
          },
          {
            second_year_commitment_price:
              filteredUnitprice * secondYearcommitment,
          },
          {
            third_year_commitment_price:
              filteredUnitprice * thirdYearcommitment,
          },
        ],
        total_price: totalPrice,
      };
      setIsloading(false);
      setIsModalLoading(true);
      editCommitment((res) => {
        const { message, success, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          commitObj && commitObj.getCommitments && commitObj.getCommitments();
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
        } else if (success === false || success === 'undefined') {
          if (error.length > 0) {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          } else {
            if (message === 'Failed to fetch') {
              ModalService.openAlert(
                '',
                'Oops, something went wrong check you internet connection and try again later',
                'error'
              );
            }
          }
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, editpayload);
      setCommitmentModal(!commitmentModal);
    } else if (payload.user_id && !editCommitmentId) {
      setIsloading(false);
      setIsModalLoading(true);
      addCommitment((res) => {
        const { message, success, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          // get Commitment api refresh
          commitObj && commitObj.getCommitments && commitObj.getCommitments();
          dispatch(dealerInfoAction(parseInt(userId), setIsloading));
        } else if (success === false || success === 'undefined') {
          if (error.length > 0) {
            ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          } else {
            if (message === 'Failed to fetch') {
              ModalService.openAlert(
                '',
                'Oops, something went wrong check you internet connection and try again later',
                'error'
              );
            }
          }
        }
        setIsloading(false);
        setIsModalLoading(false);
      }, payload);
      setCommitmentModal(!commitmentModal);
    }
    setCommitmentModal(!commitmentModal);
  };

  const handleCommonUpload = (e, key) => {
    if (key === 1) {
      setIsloading(true);
      let formData = new FormData();
      for (let i = 0; i < e.target.files.length; i++) {
        formData.append('files', e.target.files[i]);
      }
      formData.append('ownerimage', false);
      dealerDocumentUpload((res) => {
        const { success, data, error } = res;
        if (success === true) {
          let payLoad = {
            id: userId,
            commitment: data.imageUrl,
          };
          editDealer((resp) => {
            const { success } = resp;
            if (success === true) {
              dispatch(dealerInfoAction(parseInt(userId), setIsloading));
            }
          }, payLoad);
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, formData);
    }
  };

  const handleWpShare = (userId) => {
    if (activeOwner.length > 0) {
      let domElements = document.querySelectorAll('#previewModal');
      domElements.forEach((element, i) => {
        html2canvas(element, {
          width: window.innerWidth
        }).then(async (canvas) => {
          const data64Url = canvas.toDataURL('image/jpeg');

          const pdf = new jsPDF();
          pdf.addImage(data64Url, 'jpeg', 38, 0);
          let blob = pdf.output('datauristring');

          const newFile = await UrlService.urltoFile({
            url: blob,
            fileMimeType: 'aplication/pdf',
            fileName: `image-${Math.floor(10000 * Math.random()).toString()}-${Math.floor(10000 * Math.random()).toString()}.pdf`
          });

          const isSectionLast = domElements.length === i + 1;
          if (isSectionLast) {
            let formData = new FormData();
            formData.append('files', newFile);
            dealerDocumentUpload((res) => {
              const { success, data, error } = res;
              if (success === true) {
                let image = data.imageUrl;
                let phone = activeOwner[0].whatsapp_mobile_number;
                if (image && phone) {
                  window.open(
                    'https://web.whatsapp.com/send?phone=91' +
                    phone +
                    '&text=' +
                    image,
                    '_blank'
                  );
                }
              } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
              }
            }, formData);
          }
        });
      });
    } else {
      ModalService.openAlert(
        '',
        'Please fill up owner Information first',
        'error'
      );
    }
  };

  const handleEmailShare = (userId) => {
    if (activeOwner.length > 0) {
      let domElements = document.querySelectorAll('#previewModal');

      domElements.forEach((element, i) => {
        html2canvas(element, {
          width: window.innerWidth,
        }).then(async (canvas) => {
          const data64Url = canvas.toDataURL('image/jpeg');

          const pdf = new jsPDF();
          pdf.addImage(data64Url, 'jpeg', 38, 0);
          let blob = pdf.output('datauristring');

          const newFile = await UrlService.urltoFile({
            url: blob,
            fileMimeType: 'aplication/pdf',
            fileName: `image-${Math.floor(10000 * Math.random()).toString()}-${Math.floor(10000 * Math.random()).toString()}.pdf`
          });

          const isSectionLast = domElements.length === i + 1;
          if (isSectionLast) {

            let formData = new FormData();
            formData.append('files', newFile);
            dealerDocumentUpload((res) => {
              const { success, data, error } = res;
              if (success === true) {
                let Email = activeOwner[0].email;
                let doc = data.imageUrl;
                if (Email && doc) {
                  window.location = `mailto:${Email}?subject=Business Commitment for Next 3 Financial Year&body=${doc}`;
                }
              } else if (success === false || success === 'undefined') {
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
              }
            }, formData);
          }
        });
      });
    } else {
      ModalService.openAlert(
        '',
        'Please fill up owner Information first',
        'error'
      );
    }
  };

  const handleDownLoad = () => {
    let domElements = document.querySelectorAll('#previewModal');
    domElements.forEach((element, i) => {
      html2canvas(element, {
        width: window.innerWidth,
      }).then((canvas) => {
        const data64Url = canvas.toDataURL('image/jpeg');
        const pdf = new jsPDF();
        pdf.addImage(data64Url, 'jpeg', 38, 0);
        const isSectionLast = domElements.length === i + 1;
        if (isSectionLast) {
          pdf.save();
        }
      });
    });
  };

  const handleBack = () => {
    const lastRoute = Storage.backBreadcrumbsButton();
    navigate(lastRoute.url, { replace: true });
  };

  const handleSaveAsDraft = () => {
    let dealerPayload = {
      id: parseInt(userId),
      page_5: 0,
    };
    if (commitObj && commitObj.commitmentData && commitObj.commitmentData.length >= 0) {
      setIsloading(true);
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          const lastRoute = Storage.backBreadcrumbsButton();
          navigate(lastRoute.url, { replace: true });
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, dealerPayload);
    }
  };

  const finalSubmit = () => {
    let dealerPayload = {
      id: parseInt(userId),
      page_5: 1,
    };
    if (commitObj && commitObj.commitmentData && commitObj.commitmentData.length > 0) {
      setIsloading(true);
      editDealer((res) => {
        const { success, message, error } = res;
        if (success === true) {
          ModalService.openAlert('', message, 'success');
          setIsloading(false);
          const lastRoute = Storage.backBreadcrumbsButton();
          navigate(lastRoute.url, { replace: true });
        } else if (success === false || success === 'undefined') {
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
          setIsloading(false);
        }
        setIsloading(false);
      }, dealerPayload);
    }
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='BusinessCommitment'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                        <DashBoardTitle
                          dashBorardName={
                            title.page === 1 ? title.name : 'New Dealer Registration'
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12}>
                      <Breadcrumbs title='Business Commitment' />
                    </Col>
                  </Row>
                  {isPrinting ? <Document isPrinting={isPrinting} /> : null}
                  <div className='commitBlock'>
                    <div className='commitBlockInner'>
                      <Row>
                        <Col xs={12}>
                          <div className='dealerRegBlocktitle text-center noprint'>
                            Business Commitment
                          </div>
                          <p>
                            <b>Note:</b> Click on "preview" button after taking business
                            commitment. You will find an option to share a business
                            commitment letter with a dealer/distributor. Take a print out
                            on dealer/distributor's letter head and get it signed and
                            stamped. Take a photo of the letter and upload here. Post that
                            click on Submit button to complete this step.
                          </p>
                        </Col>
                        <Col xs={12}>
                          <div className='tableArea'>
                            {commitObj && commitObj.commitmentData && commitObj.commitmentData.length > 0 && (
                              <div className='d-flex flex-wrap align-items-center justify-content-center uploadBlock'>
                                <div className='dealerRegBlocktitle text-capitalize mr-3 pb-0 onprint'>
                                  Business Commitment for Next 3 Financial Year
                                </div>
                                <div className='d-flex align-items-center'>
                                  {upload && upload ? (
                                    <>
                                      <Label className='custom-file-upload mb-0 noprint'>
                                        <Input
                                          type='file'
                                          name='upload'
                                          onChange={(e) => {
                                            handleCommonUpload(e, 1);
                                          }}
                                        />
                                        {upload && (
                                          <img
                                            src={downloadImg}
                                            alt='downloadIcon'
                                            onClick={() => window.open(upload, '_blank')}
                                            className='uploadIcon'
                                          />
                                        )}
                                      </Label>
                                    </>
                                  ) : (
                                    <>
                                      <Label className='custom-file-upload mb-0 noprint'>
                                        <Input
                                          type='file'
                                          name='upload'
                                          onChange={(e) => {
                                            handleCommonUpload(e, 1);
                                          }}
                                        />
                                        <img src={uploadImg} alt='uploadIcon' className='uploadIcon' />
                                      </Label>
                                    </>
                                  )}
                                </div>
                              </div>
                            )}
                            <CommonCommitment
                              userId={userId}
                              commitData={getCommitData}
                              upload={upload}
                              handleEditCommitment={handleEditCommitment}
                            />
                          </div>
                        </Col>
                        <Col xs={12} className='text-center'>
                          <div className='addUserBtnBlock d-flex flex-wrap justify-content-center'>
                            <AddUserButton onClick={(e) => handleAddCommitment(e, 1)} name={commitObj && commitObj.commitmentData && commitObj.commitmentData.length > 0 ? 'Add New Products' : 'Add Business Commitment'} />
                          </div>
                        </Col>
                        <Col xs={12}>
                          <div className='common-buttons d-flex flex-wrap align-items-center justify-content-center'>
                            {isKycRequired ? (
                              <CommonButton name={'Cancel'} btnClass={'btnSecondary'} type="button" onClick={handleBack} />
                            ) : (
                              <CommonButton name={'Save as Draft'} btnClass={'btnSecondary'} type="button" onClick={handleSaveAsDraft} />
                            )}
                            {commitObj && commitObj.commitmentData && commitObj.commitmentData.length > 0 && (
                              <CommonButton name={'Preview'} btnClass={'btnSecondary'} type="button" onClick={() => setPreviewModal(!previewModal)} />
                            )}
                            <CommonButton name={'Submit'} btnClass={'btnPrimary'} type="button" onClick={finalSubmit} disabled={!upload} />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  {isPrinting ? <Document2 /> : null}
                </Container>
              </div>

              {/* Add/Edit Commitment Modal */}
              <CommitmentModal
                isModalLoading={isModalLoading}
                isOpen={commitmentModal}
                toggle={() => setCommitmentModal(!commitmentModal)}
                editCommitmentId={editCommitmentId}
                productId={productId}
                product={product}
                commitment={commitment}
                secondYearcommitment={secondYearcommitment}
                thirdYearcommitment={thirdYearcommitment}
                productUnit={productUnit}
                handleProduct={handleProduct}
                handleSubmitCommmitment={handleSubmitCommmitment}
              />

              {/* Preview Modal */}
              <Modal
                id='previewModal'
                isOpen={previewModal}
                toggle={() => setPreviewModal(!previewModal)}
                className='previewModal'
                centered
              >
                {isModalLoading && <CustomSpinner />}
                <ModalBody className='pb-0 text-center'>
                  <div className='d-flex justify-content-end mb-2 closeModalBtn noprint'>
                    <img
                      data-html2canvas-ignore='true'
                      src={closeImg}
                      alt='closeIcon'
                      onClick={() => setPreviewModal(!previewModal)}
                    />
                  </div>
                  <Container>
                    <Row>
                      <Col xs={12}>
                        <Document
                          selectedState={selectedState}
                          businessName={navigationName}
                          selectedTerritory={selectedTerritory}
                        />
                      </Col>
                      <Col xs={12}>
                        <div className='tableArea mb-4'>
                          {commitObj && commitObj.commitmentData && commitObj.commitmentData.length > 0 ? (
                            <div className='d-flex flex-wrap align-items-center justify-content-center uploadBlock'>
                              <div className='dealerRegBlocktitle text-capitalize mr-3 pb-0 onprint'>
                                Business Commitment for Next 3 Financial Year
                              </div>
                            </div>
                          ) : ''}
                          {commitObj && commitObj.commitmentData && commitObj.commitmentData.length > 0 ? (
                            <Table responsive className='text-center mb-0'>
                              <thead>
                                <tr>
                                  <th>Product Name</th>
                                  <th>{fYYear.next3FinancialYear[0]}</th>
                                  <th>{fYYear.next3FinancialYear[1]}</th>
                                  <th>{fYYear.next3FinancialYear[2]}</th>
                                  <th>Total</th>
                                </tr>
                              </thead>
                              <tbody>
                                {commitObj.commitmentData.map((row, i) => {
                                  return (
                                    <tr key={i}>
                                      <td key={100}>{row.product_name}</td>
                                      <td>
                                        {row.commitments &&
                                          row.commitments[0]
                                            .first_year_commitment}{' '}
                                        {row.unit_type}
                                      </td>
                                      <td>
                                        {row.commitments &&
                                          row.commitments[1]
                                            .second_year_commitment}{' '}
                                        {row.unit_type}
                                      </td>
                                      <td>
                                        {row.commitments &&
                                          row.commitments[2]
                                            .third_year_commitment}{' '}
                                        {row.unit_type}
                                      </td>
                                      <td key={104} style={{ fontWeight: '700' }}>
                                        {row.total} {row.unit_type}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </Table>
                          ) : ''}
                        </div>
                      </Col>
                      <Col xs={12}>
                        <Document2 />
                      </Col>
                    </Row>
                  </Container>
                  <div className='divider mb-1' />
                  <div
                    data-html2canvas-ignore='true'
                    className='shareBlock d-flex flex-wrap align-item-center justify-content-center'
                  >
                    <div className='d-flex align-items-center shareBlockInner'>
                      Share Via
                    </div>
                    <img
                      src={whatsAppImg}
                      alt='whatsAppIcon'
                      className='img-fluid shareBlockInner disableImg'
                      onClick={() => handleWpShare(userId)}
                    />
                    <img
                      src={gmailImg}
                      alt='mailIcon'
                      onClick={() => handleEmailShare(userId)}
                      className='img-fluid shareBlockInner'
                    />
                    <img
                      src={downloadImg}
                      alt='downloadIcon'
                      onClick={handleDownLoad}
                      className='img-fluid shareBlockInner'
                    />
                  </div>
                </ModalBody>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessCommitment;
